<template>
  <div class="flex items-center py-3 px-4 relative">
    <div v-if="icon" class="text-gray-400 mr-3 w-5 text-center">
      <i :class="`fas ${icon}`"></i>
    </div>
    
    <div class="flex-1">
      <div class="flex justify-between items-center mb-1">
        <span class="text-sm text-gray-600 whitespace-nowrap mr-2">{{ title }}</span>
        <div class="flex-1 flex justify-end">
          <div class="flex items-center justify-end">
            <span :class="['text-sm font-medium truncate max-w-[150px]', valueColor]">
              {{ truncatedValue }}
            </span>
            <button 
              v-if="shouldShowMoreButton(value)" 
              @click="toggleExpand" 
              class="ml-2 text-xs bg-blue-50 hover:bg-blue-100 text-blue-700 py-1 px-2 rounded transition-colors duration-200 flex items-center border border-blue-200">
              <span>{{ expanded ? 'Gizle' : 'Detay' }}</span>
              <i class="fas fa-chevron-down ml-1 text-xs transition-transform duration-200" :class="{'transform rotate-180': expanded}"></i>
            </button>
          </div>
        </div>
      </div>
      
      <!-- Slot for extra content like progress bars -->
      <slot name="extra"></slot>
    </div>
    
    <!-- Expanded panel -->
    <div v-if="expanded" class="expand-panel absolute left-0 right-0 mt-2 text-sm p-4 break-words border-t border-blue-200 bg-blue-50">
      <div class="font-medium text-blue-800 mb-1">{{ title }} Detayı:</div>
      <div class="text-gray-700">
        {{ value }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetailItem",
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    icon: {
      type: String,
      default: ""
    },
    valueColor: {
      type: String,
      default: "text-gray-700"
    }
  },
  data() {
    return {
      expanded: false
    };
  },
  computed: {
    truncatedValue() {
      if (typeof this.value !== 'string') return this.value;
      if (this.value.length <= 10) return this.value;
      return this.value.substring(0, 10) + '...';
    }
  },
  methods: {
    shouldShowMoreButton(value) {
      // String ise ve 15 karakterden uzun ise daha fazla göster butonu göster
      return typeof value === 'string' && value.length > 10;
    },
    toggleExpand() {
      this.expanded = !this.expanded;
    }
  }
};
</script>

<style scoped>
.expand-panel {
  width: 100%;
  overflow: hidden;
  animation: slideDown 0.3s ease-out;
  line-height: 1.5;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  top: 100%; /* Ana içerik bloğunun altına konumlandır */
  z-index: 10;
}

@keyframes slideDown {
  from {
    max-height: 0;
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    max-height: 500px;
    opacity: 1;
    transform: translateY(0);
  }
}

/* Button hover efekti */
button:hover .fas {
  transform: translateY(2px);
  transition: transform 0.2s;
}
</style>